import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";

import ListGallery from "./List";
// import MediaDetails from "./Show";
import UploadMedia from "./Create";
import EditGallery from "./Edit";

export const getGalleryResource = ({ permission }) => {
  return {
    isMenu: true,
    icon: <PhotoLibraryIcon />,
    name: "media-cms",
    title: "Галерия",
    list: <ListGallery />,
    edit: <EditGallery />,
    create: <UploadMedia />,
    // show: <MediaDetails />,
    permission,
  };
};
